module.exports = __webpack_public_path__ + "24f8193044d2f09705465efa0f3ef7bf.svg";